import React, { useContext, useState } from 'react';

import { config } from '../../config';
import { ThemeContext } from '../../contexts/theme';
import { enB, enW, ptB, ptW, svB, svW } from '../../assets/index';
import './Language.css';


const Language = () => {
  const [{ themeName }] = useContext(ThemeContext);
  const [chosenLanguage, setChosenLanguage] = useState(() => JSON.parse(localStorage.getItem('currentLanguage')) ?? 'en');

  // ------------------------------------------ Functions ---------------------------------------

  // Function that puts query to change the language
  const handleLanguageChange = (event) => {
    localStorage.setItem('currentLanguage', JSON.stringify(event.target.name));
    setChosenLanguage(event.target.name);
    const URL = config.url.APP_URL;
    window.location.replace(`${URL}?lng=${event.target.name}`);
  };

  // ------------------------------------------ Render ------------------------------------------

  return (
    <div className='language-choice'>
      <button onClick={handleLanguageChange} id='en' type='button'><img name='en' alt='United Kingdom flag' src={themeName === 'dark' ? (enW) : (enB)} className='flag-icon' /></button>
      <button onClick={handleLanguageChange} id='pt' type='button'><img name='pt' alt='Portugal flag' src={themeName === 'dark' ? (ptW) : (ptB)} className='flag-icon' /></button>
      <button onClick={handleLanguageChange} id='sv' type='button'><img name='sv' alt='Sweden flag' src={themeName === 'dark' ? (svW) : (svB)} className='flag-icon' /></button>
    </div >
  );
};

export default Language;
